<template>
  <div class="orders-main-filter">
    <subheader
      :title="title"
      class="alternative-subheader"
    />

    <div
      class="orders-main-filter__container"
      :class="{ 'additional-top-spacing': !tabSelected }"
    >
      <div class="cards-filter-container__tabs">
        <div
          id="filterTab"
          class="cards-filter-container__tabs-single"
          :class="{ 'cards-filter-container__tabs-selected': tabSelected }"
          @click="changeTab(true)"
        >
          Filtrar
        </div>
        <div
          id="consultTab"
          class="cards-filter-container__tabs-single"
          :class="{ 'cards-filter-container__tabs-selected': !tabSelected }"
          @click="changeTab(false)"
        >
          Consultar
        </div>
      </div>

      <div
        v-if="tabSelected"
        class="cards-filter-container__filter"
      >
        <div class="cards-filter-container__filter-field-area">
          <md-radio
            v-model="principalFilter.isXML"
            md-value="false"
            class="cards-filter-container__filter-checkbox"
          >
            Todas
          </md-radio>
          <md-radio
            v-model="principalFilter.isXML"
            md-value="true"
            class="cards-filter-container__filter-checkbox"
          >
            Apenas importadas (XML)
          </md-radio>
        </div>

        <div v-if="principalFilter.isXML === 'false'">
          <div class="cards-filter-container__filter-field-area">
            <md-checkbox
              v-model="principalFilter.correct"
              md-value="CORRECT"
              class="cards-filter-container__filter-checkbox"
            >
              Corretas
            </md-checkbox>
            <md-checkbox
              v-model="principalFilter.fixed"
              md-value="FIXED"
              class="cards-filter-container__filter-checkbox"
            >
              Corrigidas
            </md-checkbox>
            <md-checkbox
              v-model="principalFilter.error"
              md-value="ERROR"
              class="cards-filter-container__filter-checkbox"
            >
              Com erro
            </md-checkbox>
          </div>

          <div class="cards-filter-container__filter-field-area">
            <md-checkbox
              v-model="principalFilter.transmitted"
              class="cards-filter-container__filter-checkbox"
              md-value="T"
            >
              Transferidas
            </md-checkbox>
            <md-checkbox
              v-model="principalFilter.pending_transmit"
              md-value="P"
              class="cards-filter-container__filter-checkbox"
            >
              Não Transferidas
            </md-checkbox>
          </div>
        </div>

        <div v-else>
          <div class="cards-filter-container__filter-field-area">
            <div class="date-range-container">
              <date-picker-range
                :date-selected.sync="date"
                :date-filter-alternative="true"
                :limit-data="limitData"
                :default-start-date="defaultStartDate"
                :default-end-date="defaultEndDate"
                :calendar-direction="'bottom'"
                :clear-button="false"
              />
            </div>
          </div>
          <div class="cards-filter-container__filter-field-area">
            <md-layout
              v-if="filesSentStatus === 'STATUS_END'"
              md-flex="15"
              class="itemSelect"
              md-flex-medium="20"
            >
              <md-tooltip
                v-if="filesAvailables.length === 0"
                md-direction="top"
              >
                Não foram encontrados arquivos para o período selecionado.
              </md-tooltip>
              <model-list-select
                id="comboFiles"
                v-model="principalFilter.files"
                v-validate="'required'"
                option-text="name"
                class="combo-box"
                placeholder="Selecione um arquivo"
                :options="getAvailableFiles()"
                option-value="id_file"
              >
                <span slot="no-options">Não foram encontrados arquivos para o período selecionado.</span>
              </model-list-select>
            </md-layout>
            <div v-else>
              <spinner class="small search__loading" />
            </div>
          </div>
        </div>

        <div class="cards-filter-container__filter-container-button">
          <md-button
            class="btn btn-primary cards-filter-container__filter-button cards-filter-container__filter-button-right"
            @click="submitSearch('filter')"
          >
            <md-icon md-src="/static/images/icon-generate-list.svg" />Listar Ordens de Serviço
          </md-button>
        </div>
      </div>

      <div
        v-else
        class="cards-filter-container__filter"
      >
        <div class="cards-filter-container__filter-field-area">
          <div class="input-layout-container">
            <p class="input-layout-container-label">
              Paciente <br>/ <template v-if="!toggle.covax">
                OS LIS
              </template><template v-else>
                REQUISITION NUMBER
              </template>
            </p>
            <md-input-container>
              <md-input v-model="consultFilter.q" />
            </md-input-container>
          </div>
        </div>

        <div class="cards-filter-container__filter-container-button">
          <md-button
            class="btn btn-primary cards-filter-container__filter-button"
            @click="submitSearch('consult')"
          >
            <md-icon :md-src="'/static/images/icon-generate-list.svg'" />Listar Ordens de Serviço
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from '../common/SubHeader'
import DatePickerRange from '../common/DatePickerRange'
import { mapGetters, mapActions } from 'vuex'
import { formartDateFromArray } from '@/utils/date-utils'
import Moment from 'moment'
import Spinner from '@/components/common/Spinner'
import { ORDER_STATE_TRANSMITTED, ORDER_STATE_PENDING_TRANSMISSION, ORDER_STATE_FAIL } from '@/enums'

export default {
  name: 'OrdersMainFilter',
  components: {
    subheader: SubHeader,
    'date-picker-range': DatePickerRange,
    spinner: Spinner
  },
  data: () => ({
    tabSelected: true,
    principalFilter: {
      correct: 'true',
      fixed: 'true',
      error: 'true',
      transmitted: 'true',
      pending_transmit: 'true',
      isXML: 'false',
      files: []
    },
    consultFilter: {
      q: ''
    },
    date: {
      start: new Date(),
      end: new Date()
    },
    filesAvailables: [],
    limitDays: 99999,
    query: '/orders?'
  }),
  computed: {
    ...mapGetters(['getTodayDate', 'profile', 'filesUploaded', 'filesSentStatus', 'patientRoutine', 'toggle']),
    title() {
      if (this.patientRoutine) {
        return 'Importação da Rotina do Paciente'
      }
      return 'Listagem de Ordens de Serviço'
    },
    today: function () {
      return formartDateFromArray(this.getTodayDate)
    },
    defaultStartDate: function () {
      return this.today
    },
    defaultEndDate: function () {
      return this.today
    },
    limitData: function () {
      let today = formartDateFromArray(this.getTodayDate)
      return Moment(today, 'DD/MM/YYYY').subtract(this.limitDays, 'days').toDate()
    }
  },
  watch: {
    date: function (newValue) {
      this.updateFiles()
      this.principalFilter.files = []
    },
    filesUploaded: function (newValue) {
      this.filesAvailables = newValue
      this.getAvailableFiles()
    }
  },
  created() {
    this.updateToday()
  },
  mounted() {
    if (this.$strings.limitDaysForCalendar && this.$route.meta.limitDaysParam) {
      this.limitDays = this.$strings.limitDaysForCalendar[this.$route.meta.limitDaysParam]
    }
    if (this.$route.query.filterBy) {
      this.principalFilter.fixed = this.$route.query.filterBy.includes('FIXED')
      this.principalFilter.correct = this.$route.query.filterBy.includes('CORRECT')
      this.principalFilter.error = this.$route.query.filterBy.includes('ERROR')
      this.principalFilter.pending_transmit = this.$route.query.filterBy.includes(ORDER_STATE_PENDING_TRANSMISSION)
      this.principalFilter.transmitted = this.$route.query.filterBy.includes(ORDER_STATE_TRANSMITTED)
    }
    if (this.$route.query.q) {
      this.consultFilter.q = this.$route.query.q
    }
    this.updateFiles()
  },
  beforeDestroy() {
    this.setOrderShowOff(false)
    this.query = '/orders?'
  },
  methods: {
    ...mapActions(['updateToday', 'setOrderShowOff', 'updateResultFilters', 'getFilesSent']),
    getAvailableFiles() {
      if (!this.filesUploaded) {
        return []
      }
      let clonedFilesArray = this.filesUploaded.slice(0)
      clonedFilesArray.map(function (elem) {
        elem.label = elem.name
        elem.value = elem.id_file
      })
      return clonedFilesArray
    },
    updateFiles() {
      let params = {
        startDate: Moment(this.date.start).format('DD/MM/YYYY'),
        endDate: Moment(this.date.end).format('DD/MM/YYYY'),
        idLaboratory: this.profile.id_laboratory
      }
      this.getFilesSent(params)
    },
    changeTab(value) {
      this.tabSelected = value
    },
    createQuery(value) {
      if (this.patientRoutine) {
        this.query = '/patient-routine?'
      }
      let q = ''
      switch (value) {
        case 'filter':
          if (this.principalFilter.isXML === 'false') {
            if (this.principalFilter.fixed) {
              this.query = this.query.concat('&filterBy=' + 'FIXED')
            }
            if (this.principalFilter.correct) {
              this.query = this.query.concat('&filterBy=' + 'CORRECT')
            }
            if (this.principalFilter.error) {
              this.query = this.query.concat('&filterBy=' + 'ERROR')
            }
            if (this.principalFilter.transmitted) {
              this.query = this.query.concat('&filterBy=' + ORDER_STATE_TRANSMITTED)
            }
            if (this.principalFilter.pending_transmit) {
              this.query = this.query.concat('&filterBy=' + ORDER_STATE_PENDING_TRANSMISSION)
              this.query = this.query.concat('&filterBy=' + ORDER_STATE_FAIL)
            }
          } else {
            if (this.principalFilter.files.value) {
              this.query = this.query.concat('&idFile=' + this.principalFilter.files.value)
            } else {
              this.query = '/orders?'
            }
          }
          break
        case 'consult':
          if (this.consultFilter.q) {
            q = this.consultFilter.q
            q = q.replace(/[%¨!@#$&*()+=\\-_]/gi, '')
            this.query = this.query.concat('&q=' + q)
          }
          break
      }
    },
    submitSearch(value) {
      this.createQuery(value)
      this.$router.push({ path: this.query })
      this.setOrderShowOff(false)
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';

.orders-main-filter {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-top: $mainHeaderHeight;

  .additional-top-spacing {
    margin-top: 3%;
  }

  .v-select input[type='search'],
  .v-select input[type='search']:focus {
    color: #030303;
    text-transform: initial;
    text-align: left;
    font-size: 12px;
    font-weight: 450;
    letter-spacing: 1px;
  }

  .v-select .vs__selected {
    text-transform: initial;
    color: #7a7a7a;
    text-align: left;
    font-size: 12px;
    font-weight: 450;
    letter-spacing: 1px;
  }

  .v-select.dropdown.open .vs__dropdown-menu,
  .v-select.dropdown.open .vs__dropdown-toggle {
    color: #030303;
    text-transform: initial;
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 1px;
  }

  &__container {
    flex-flow: column wrap;
    display: block;
    min-width: 670px;
  }

  .additional-top-spacing {
    margin-top: 3%;
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    /* IE10+ */
    .orders-main-filter__container {
      margin: auto auto 10% auto;
    }
  }

  &__title {
    line-height: 26px;
    text-align: left;
    color: #7a7a7a;
    font-weight: 500;
    letter-spacing: 0.8px;
    margin-left: 1em;
    font-size: 14px;
  }

  .cards-filter-container {
    display: flex;

    &__tabs {
      display: flex;
      margin-top: 10px;
      margin-left: 15px;

      &-single {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        padding: 10px 40px 10px 40px;
        background-color: rgba(255, 255, 255, 0.5);
        margin-right: 3px;
        cursor: pointer;
        line-height: 26px;
        text-align: left;
        color: #7a7a7a;
        font-weight: 500;
        letter-spacing: 0.8px;
        font-size: 14px;
      }

      &-selected {
        background-color: white;
      }
    }

    &__filter {
      background-color: white;
      border-radius: 5px;
      border-top-left-radius: 0px;
      margin-left: 15px;
      padding: 15px;
      min-width: 500px;

      &-field-area {
        background-color: rgba(127, 26, 84, 0.1);
        padding-right: 12px;
        padding-left: 12px;
        border-radius: 5px;
        margin-bottom: 15px;
        min-height: 3em;

        .loader {
          top: 1em;
        }

        .label {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 500;
          padding-top: 5px;
          padding-right: 15px;
          letter-spacing: 1px;
          text-transform: uppercase;
          position: relative;
          bottom: 0.3em;
        }
      }

      &-container-button {
        display: flex;
        justify-content: flex-end;
      }

      &-button {
        width: 48%;

        &-right {
          margin-left: 3%;
        }
      }

      .btn-nonenary {
        .md-icon {
          > svg .color {
            fill: $brand-primary;
            transition: 0.6s;
          }
        }

        &:hover .md-icon > svg .color {
          fill: white;
          transition: 0.6s;
        }
      }

      .md-input-container {
        background-color: white;
        border-radius: 5px;
        min-height: auto;
        margin: 0px;
        padding-top: 0px;
        padding-right: 10px;
      }

      .input-layout-container,
      .date-range-container {
        display: flex;

        &-label {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 500;
          padding-top: 5px;
          padding-right: 10px;
          letter-spacing: 1px;
          text-transform: uppercase;
        }
      }
      .date-range-container {
        padding-top: 15px;
        padding-bottom: 15px;

        .search-bar__date {
          margin: 0;
        }

        .md-input-container input,
        .md-input-container textarea {
          min-width: 240px;
        }

        .md-input-container.md-has-value input,
        .md-input-container.md-has-value textarea,
        .md-input-container.md-input-focused input,
        .md-input-container.md-input-focused textarea {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 450;
          padding-left: 10px;
          letter-spacing: 1px;
        }
      }

      .date-range-container,
      .input-layout-container {
        padding-top: 7px;
        padding-bottom: 7px;

        &-label {
          justify-content: right;
          display: flex;
        }

        .md-input-container.md-has-value input,
        .md-input-container.md-has-value textarea,
        .md-input-container.md-input-focused input,
        .md-input-container.md-input-focused textarea {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 450;
          padding-left: 10px;
          letter-spacing: 1px;
        }
      }

      .date-range-container {
        .md-input-container {
          max-width: 100%;

          &::after {
            display: none;
          }
        }
      }

      .input-layout-container {
        .md-input-container {
          flex: 2;

          &::after {
            display: none;
          }
        }
      }

      .md-checkbox {
        margin-right: 2em;
        margin-top: 13px;
        margin-bottom: 13px;

        .md-checkbox-container {
          background-color: white;
          border: 2px solid rgba(255, 255, 255, 1);
          border-radius: 3px;
        }
      }

      .md-theme-default.md-checkbox.md-checked .md-checkbox-container {
        background-color: $brand-primary;
        border: 2px solid $brand-primary;
      }

      .md-checkbox-label {
        color: #7a7a7a;
        text-align: left;
        font-size: 12px;
        font-weight: 500;
        padding-bottom: 10px;
        letter-spacing: 0.8px;
      }

      .md-radio {
        margin-right: 2em;

        .md-radio-container {
          background-color: white;
          border: 2px solid rgba(255, 255, 255, 1);
        }
      }

      .md-theme-default.md-radio.md-checked .md-radio-container {
        background-color: white;
        border: 2px solid white;
      }

      .md-radio-label {
        color: #7a7a7a;
        text-align: left;
        font-size: 12px;
        font-weight: 500;
        padding-bottom: 10px;
        letter-spacing: 0.8px;
      }

      .md-theme-default.md-radio .md-radio-container::after {
        background-color: $brand-primary;
      }
    }
  }

  .combo-box {
    width: 100%;
    background: white;
    margin: 12px 0;
    border-radius: 4px;
    padding-left: 10px;
  }

  .vs__dropdown-menu {
    width: 100%;
  }
}
</style>
